import axios from "axios";
import { Component } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { confirmAlert } from "react-confirm-alert";
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import noImg from "../../images/no-img.png";
import pdfIcon from "../../images/pdfIcon.png";
import {
  TaxTypeOptions,
  URL,
  fotoStyle,
  fotoStyle2,
  localFilePath,
  optionOfferStatusesOptions,
} from "../../redux/actions/constants";
import NoteAddUpdate from "../notes/NoteAddUpdate";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButton from "../toolbox/CgnButton";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";

class OfferDetail extends Component {
  state = {
    pageTitle: "Teklif Detay",
    pageTitleDetail: "Teklif Detay",
    pageAddLink: "teklif-ekle",
    pageListLink: "teklif-listele",
    breadcrumb: [{ text: "Teklif", link: "#" }],
    isLoading: false,
    urlSplit: [],
    alertErrorMessage: "",
    offerNumber: "",
    offerDate: "",
    customerName: "",
    total: null,
    costTotal: null,
    generalCostTotal: null,
    notDescription: "",
    taxTotal: null,
    discountPercent: "",
    customerPhone: "",
    discountValue: "",
    discountTotal: "",
    discountCostTotal: "",
    taxType: null,
    taxRate: null,
    currencyType: 0,
    description: "",
    productDto: [],
    customerEmail: "",
    productName: "",
    piece: null,
    oldOfferDocumentDto: [],
    oldOfferImageDto: [],
    unitPrice: null,
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedByF: "",
    offerCoverImage: "",
    confirmationDate: "",
    teklifIptalSebebi: "",
    noteDto: [],
    isOpenModalNote: false,
    isOpenModalUpdateNote: false,
    noteGuid: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit[2],
    });
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      //
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/offers/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            customerName: response.data.customerName,
            offerNumber: response.data.offerNumber,
            offerDate: response.data.offerDate,
            optionDate: response.data.optionDate,
            reminderDate: response.data.reminderDate,
            productDto: response.data.offerProductDto,
            costTotal: response.data.costTotal.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            total: response.data.total.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            generalCostTotal: response.data.generalCostTotal.toLocaleString(
              "tr-TR",
              {
                minimumFractionDigits: 2,
              }
            ),
            generalTotal: response.data.generalTotal.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            discountPercent: response.data.discountPercent,
            discountValue: response.data.discountValue.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            discountCostTotal: response.data.discountCostTotal.toLocaleString(
              "tr-TR",
              {
                minimumFractionDigits: 2,
              }
            ),
            discountTotal: response.data.discountTotal.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            taxTotal: (
              response.data.generalTotal *
              (response.data.taxRate / 100)
            ).toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
            }),
            currencyType: response.data.currencyType,
            customerEmail: response.data.customerEmail,
            customerPhone: response.data.customerPhone,
            taxType: response.data.taxType,
            taxRate: response.data.taxRate,
            guaranty: response.data.guaranty,
            paymentMethodType: response.data.paymentMethodType,
            deliveryMethodType: response.data.deliveryMethodType,
            deliveryTime: response.data.deliveryTime,
            description: response.data.description,
            offerCoverImage: response.data.offerCoverImage,
            confirmationDate: response.data.confirmationDate,
            offerCancelText: response.data.offerCancelText,
            oldOfferDocumentDto: response.data.oldOfferDocumentDto,
            oldOfferImageDto: response.data.oldOfferImageDto,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            notDescription: response.data.notDescription,
            exchangeRate: response.data.exchangeRate,
            isExchangeRate: response.data.isExchangeRate,
            discountTotalExchangeRate: response.data.discountTotalExchangeRate,
            isLoading: false,
            teklifIptalSebebi: response.data.teklifIptalSebebi,
            noteDto: response.data.noteDto,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  handlePdfPrint = async (guid) => {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/offers/offerPrint/" + guid, config)
      .then((response) => {
        var myData = response.data;
        let replaceLink = myData.replace(localFilePath, "");
        if (replaceLink) {
          window.open(replaceLink, "_blank");
          this.setState({
            isLoading: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  toggle = (image) => {
    this.setState({
      isOpen: !this.state.isOpen,
      isImage: image,
    });
  };

  fileClick = (image) => {
    var myData = image;
    let replaceLink = myData.replace(localFilePath + "/Files/", "");
    if (replaceLink) {
      window.open("/Files/" + myData, "_blank");
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePdfSendMail = async (guid) => {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/offers/offerSendMail/" + guid, config)
      .then((response) => {
        confirmAlert({
          title: CgnMessage.sendMailTitle,
          message: response.data,
          buttons: [
            {
              label: CgnMessage.sendMailConfirm,
              className: "offerListSendMailAlert",
            },
          ],
        });
        this.setState({
          isLoading: false,
        });
      })
      .catch((error) => {
        confirmAlert({
          title: CgnMessage.sendMailTitle,
          message: error.response.data,
          buttons: [
            {
              label: CgnMessage.sendMailConfirm,
              className: "offerListSendMailAlert",
            },
          ],
        });
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  addModalNote = () => {
    this.setState({
      isOpenModalNote: !this.state.isOpenModalNote,
    });
  };

  addModalUpdateNote = (guid) => {
    this.setState({
      isOpenModalUpdateNote: !this.state.isOpenModalUpdateNote,
      noteGuid: guid,
    });
  };

  handleNoteDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.handleNoteSendDelete(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  handleNoteSendDelete = async (guid) => {
    this.setState({
      isLoading: true,
    });
    //
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/notes/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };
    const subRow = {
      backgroundColor: "#f2f2f2",
    };

    var self1 = this;
    var self = this.state;

    var phone = this.state.customerPhone,
      maskPhone = `${phone.substring(0, 1)}  ${
        "(" + phone.substring(1, 4) + ")"
      } ${phone.substring(4, 7)} ${phone.substring(7, 9)} ${phone.substring(
        9,
        11
      )}`;

    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
          noteLink={(onClick) => this.addModalNote()}
        />
        <Row>
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}

              <Table className="table table-responsive table-hover">
                <tr>
                  <th>Müşteri</th>
                  <td colSpan="4">{this.state.customerName}</td>
                </tr>
                <tr>
                  <th>Müşteri E-mail</th>
                  <td colSpan="4">{this.state.customerEmail}</td>
                </tr>
                <tr>
                  <th>Müşteri Telefon</th>
                  <td colSpan="4">
                    {this.state.customerPhone === "" ? "-" : maskPhone}
                  </td>
                </tr>
                <tr>
                  <th>Teklif Tarihi</th>
                  <td colSpan="4">{this.state.offerDate}</td>
                </tr>
                <tr>
                  <th>Teklif No</th>
                  <td colSpan="4">{this.state.offerNumber}</td>
                </tr>
                <tr>
                  <th>Opsiyon Tarihi</th>
                  <td colSpan="4">{this.state.optionDate}</td>
                </tr>

                <tr>
                  <th>Hatırlatma Tarihi</th>
                  <td colSpan="4">{this.state.reminderDate}</td>
                </tr>

                <tr>
                  <th>Maliyet Tutar</th>
                  <td colSpan="4">
                    {this.state.costTotal !== "0,00" && this.state.costTotal
                      ? this.state.costTotal +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Tutar</th>
                  <td colSpan="4">
                    {this.state.total
                      ? this.state.total +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>İskonto(Yüzde)</th>
                  <td colSpan="4">
                    {this.state.discountPercent
                      ? "% " + this.state.discountPercent
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>İskonto(Net Tutar)</th>
                  <td colSpan="4">
                    {this.state.discountValue && this.state.discountValue > 0
                      ? this.state.discountValue +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Maliyet Genel Tutar</th>
                  <td colSpan="4">
                    {this.state.generalCostTotal !== "0,00" &&
                    this.state.generalCostTotal
                      ? this.state.generalCostTotal +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Genel Tutar</th>
                  <td colSpan="4">
                    {this.state.generalTotal
                      ? this.state.generalTotal +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>K.D.V. Türü</th>
                  <td colSpan="4">{TaxTypeOptions(this.state.taxType)}</td>
                </tr>

                <tr>
                  <th>K.D.V. Oranı</th>
                  <td>
                    {this.state.taxRate ? "% " + this.state.taxRate : "-"}
                  </td>

                  <th>K.D.V. Tutarı</th>
                  <td>
                    {this.state.taxTotal
                      ? this.state.taxTotal +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Maliyet Toplam Tutar</th>
                  <td colSpan="4">
                    {this.state.discountCostTotal !== "0,00" &&
                    this.state.discountCostTotal
                      ? this.state.discountCostTotal +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Toplam Tutar</th>
                  <td colSpan="4">
                    {this.state.discountTotal
                      ? this.state.discountTotal +
                        " " +
                        (this.state.currencyType === 1
                          ? "₺"
                          : this.state.currencyType === 2
                          ? "$"
                          : this.state.currencyType === 3
                          ? "€"
                          : "-")
                      : "-"}
                  </td>
                </tr>

                {(this.state.currencyType === 2 ||
                  this.state.currencyType === 3) && (
                  <>
                    <tr>
                      <th>Döviz Kuru</th>
                      <td colSpan="4">
                        {this.state.exchangeRate
                          ? this.state.exchangeRate.toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                            }) + " ₺"
                          : "-"}
                      </td>
                    </tr>

                    <tr>
                      <th>Toplam Tutar (₺)</th>
                      <td colSpan="4">
                        {this.state.discountTotalExchangeRate
                          ? this.state.discountTotalExchangeRate.toLocaleString(
                              "tr-TR",
                              {
                                minimumFractionDigits: 2,
                              }
                            ) + " ₺"
                          : "-"}
                      </td>
                    </tr>
                  </>
                )}

                <tr>
                  <th>Ödeme Yöntemi </th>
                  <td colSpan="4">{this.state.paymentMethodType}</td>
                </tr>

                <tr>
                  <th>Teslimat Yöntemi </th>
                  <td colSpan="4">{this.state.deliveryMethodType}</td>
                </tr>

                <tr>
                  <th>Teslimat Süresi </th>
                  <td colSpan="4">{this.state.deliveryTime}</td>
                </tr>

                <tr>
                  <th>Garanti Süresi </th>
                  <td colSpan="4">{this.state.guaranty}</td>
                </tr>

                <tr>
                  <th>Teklif Notu</th>
                  <td
                    colSpan="4"
                    dangerouslySetInnerHTML={{
                      __html: this.state.description
                        ? this.state.description
                        : "-",
                    }}
                  >
                    {/* {this.state.description ? this.state.description : "-"} */}
                  </td>
                </tr>

                <tr>
                  <th>Firma Notu</th>
                  <td colSpan="4">
                    {this.state.notDescription
                      ? this.state.notDescription
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Teklif Kapağı</th>
                  <td colSpan="4">
                    {this.state.offerCoverImage ? (
                      <Button
                        onClick={this.toggle}
                        className="modalButtonDetail"
                      >
                        <img
                          src={this.state.offerCoverImage}
                          style={fotoStyle}
                          alt={this.state.name}
                        />
                      </Button>
                    ) : (
                      <img
                        src={noImg}
                        style={fotoStyle}
                        alt={this.state.customerName}
                      />
                    )}
                  </td>
                </tr>

                <Modal isOpen={this.state.isOpen} toggle={this.toggle}>
                  <ModalHeader toggle={this.toggle}></ModalHeader>
                  <img
                    className="modalofferCoverImage"
                    src={this.state.offerCoverImage}
                    style={fotoStyle}
                    alt={this.state.customerName}
                  />
                </Modal>

                <tr>
                  <th>Teklif Onay/İptal Tarihi Saati</th>
                  <td colSpan="4">{this.state.confirmationDate}</td>
                </tr>

                {this.state.status === 3 && (
                  <tr>
                    <th>Teklif İptal Sebebi</th>
                    <td colSpan="4">
                      {this.state.teklifIptalSebebi
                        ? this.state.teklifIptalSebebi
                        : "-"}
                    </td>
                  </tr>
                )}

                <tr>
                  <th>Durum</th>
                  <td colSpan="4">
                    {optionOfferStatusesOptions(this.state.status)}
                  </td>
                </tr>

                <tr style={{ display: this.state.status === 3 ? "" : "none" }}>
                  <th>İptal Nedeni</th>
                  <td colSpan="4">
                    {this.state.offerCancelText !== ""
                      ? this.state.offerCancelText
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <th>Kaydeden Kullanıcı</th>
                  <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                  <th>Kaydedilme Tarihi</th>
                  <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                </tr>

                <tr>
                  <th>Son Güncelleyen Kullanıcı</th>
                  <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                  <th>Son Güncellenme Tarihi</th>
                  <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                </tr>
              </Table>

              {this.state.productDto !== null &&
                this.state.productDto.length > 0 &&
                this.state.productDto.map(function (item) {
                  return (
                    <Table className="table table-responsive table-hover table-product">
                      <tr className="">
                        <th style={mainRow}>Depo</th>
                        <th style={{ textAlign: "left", color: "white" }}>
                          Ürün Adı
                        </th>
                        <th className="text-center" style={mainRow}>
                          Adet
                        </th>
                        <th style={mainRow}>M. Birim Fiyatı </th>
                        <th style={mainRow}>Birim Fiyatı </th>
                        <th style={mainRow}>Maliyet Fiyat</th>
                        <th style={mainRow}>Fiyat</th>
                      </tr>
                      <tr style={subRow}>
                        <td>{item.locationName}</td>
                        <td style={{ textAlign: "left" }}>
                          {item.productCode + " / " + item.productName}
                        </td>
                        <td className="text-center">{item.piece}</td>
                        <td>
                          {item.costPrice !== 0
                            ? item.costPrice.toLocaleString("tr-TR", {
                                minimumFractionDigits: 2,
                              }) +
                              " " +
                              (item.currencyType === 1
                                ? "₺"
                                : item.currencyType === 2
                                ? "$"
                                : item.currencyType === 3
                                ? "€"
                                : "-")
                            : "-"}
                        </td>
                        <td>
                          {item.unitPrice.toLocaleString("tr-TR", {
                            minimumFractionDigits: 2,
                          }) +
                            " " +
                            (item.currencyType === 1
                              ? "₺"
                              : item.currencyType === 2
                              ? "$"
                              : item.currencyType === 3
                              ? "€"
                              : "-")}
                        </td>
                        <td>
                          {item.costTotal !== 0
                            ? item.costTotal.toLocaleString("tr-TR", {
                                minimumFractionDigits: 2,
                              }) +
                              " " +
                              (item.currencyType === 1
                                ? "₺"
                                : item.currencyType === 2
                                ? "$"
                                : item.currencyType === 3
                                ? "€"
                                : "-")
                            : "-"}
                        </td>
                        <td>
                          {item.total.toLocaleString("tr-TR", {
                            minimumFractionDigits: 2,
                          }) +
                            " " +
                            (item.currencyType === 1
                              ? "₺"
                              : item.currencyType === 2
                              ? "$"
                              : item.currencyType === 3
                              ? "€"
                              : "-")}
                        </td>
                      </tr>

                      {item.productPropertyDto != null &&
                        item.productPropertyDto.length > 0 && (
                          <tr>
                            <th
                              style={{
                                backgroundColor: "#1D4B8C",
                                color: "#fff",
                              }}
                              colSpan="7"
                              className="text-left"
                            >
                              Ürün Özellikleri
                            </th>
                          </tr>
                        )}
                      {item.productPropertyDto.map(function (item2) {
                        return (
                          <tr style={subRow}>
                            <td colSpan="2" className="text-left">
                              {item2.propertyTypeName}
                            </td>
                            <td colSpan="7" className="text-left">
                              {" "}
                              {item2.value}
                            </td>
                          </tr>
                        );
                      })}
                    </Table>
                  );
                })}

              {this.state.oldOfferDocumentDto &&
                this.state.oldOfferDocumentDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2">
                    <tr style={mainRow}>
                      <th>Belgeler</th>
                    </tr>
                    <Row>
                      {this.state.oldOfferDocumentDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-4">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}

              {this.state.oldOfferImageDto !== null &&
                this.state.oldOfferImageDto.length > 0 && (
                  <>
                    <Table className="table table-responsive table-hover table-product2">
                      <tr style={mainRow}>
                        <th>Teklif Fotoğrafı</th>
                      </tr>
                      <Row>
                        {this.state.oldOfferImageDto.map(function (item) {
                          return (
                            <>
                              <div className="pl-4">
                                {item.image ? (
                                  <Button
                                    onClick={() => self1.toggle(item.image)}
                                    className="modalButtonDetail"
                                  >
                                    <img
                                      src={item.image}
                                      style={fotoStyle}
                                      alt={item.errorCodeName}
                                    />
                                  </Button>
                                ) : (
                                  <img
                                    src={noImg}
                                    style={fotoStyle}
                                    alt={item.errorCodeName}
                                  />
                                )}
                              </div>
                              <Modal isOpen={self.isOpen} toggle={self1.toggle}>
                                <ModalHeader
                                  toggle={self1.toggle}
                                ></ModalHeader>
                                <img
                                  className="modalImage"
                                  src={self.isImage}
                                  style={fotoStyle}
                                  alt={item.errorCodeName}
                                />
                              </Modal>
                            </>
                          );
                        })}
                      </Row>
                    </Table>
                  </>
                )}

              {this.state.noteDto !== null && this.state.noteDto.length > 0 && (
                <>
                  <div
                    className="row"
                    style={{
                      display:
                        self.noteDto !== null && self.noteDto.length > 0
                          ? ""
                          : "none",
                    }}
                  >
                    <h2 className="mt-2">Not</h2>
                  </div>
                  <Table className="table table-responsive table-product2">
                    <tr className=""></tr>
                    {this.state.noteDto.map(function (item) {
                      return (
                        <tbody>
                          <>
                            <Accordion allowZeroExpanded>
                              <AccordionItem>
                                <AccordionItemHeading
                                  style={{ backgroundColor: "#9B9796" }}
                                >
                                  <AccordionItemButton>
                                    <tr className="cuttingTr4 w-100">
                                      <th
                                        className="pl-3"
                                        style={self1.thStyle3}
                                      >
                                        Not Başlığı
                                      </th>
                                      <td style={self1.tdStyle2}>
                                        {item.title}
                                      </td>
                                    </tr>
                                  </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                  <table className="table table-responsive table-hover w-full">
                                    <tr></tr>
                                    <tr>
                                      <th className="pl-3">
                                        Ekleyen Kullanıcı
                                      </th>
                                      <td className="text-left">
                                        {item.createdBy}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="pl-3">Not</th>
                                      <td className="text-left">
                                        {item.description}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th className="pl-3">Fotoğraflar</th>
                                      <td className="text-left">
                                        {item.notePictureDto !== null &&
                                          item.notePictureDto.length > 0 && (
                                            <Row>
                                              {item.notePictureDto.map(
                                                function (itemNotePicture) {
                                                  return (
                                                    <>
                                                      <div className="pr-4">
                                                        {itemNotePicture.image ? (
                                                          <Button
                                                            onClick={() =>
                                                              self1.toggle(
                                                                itemNotePicture.image
                                                              )
                                                            }
                                                            className="modalButtonDetail"
                                                          >
                                                            <img
                                                              src={
                                                                itemNotePicture.image
                                                              }
                                                              style={fotoStyle}
                                                              alt={
                                                                itemNotePicture.errorCodeName
                                                              }
                                                            />
                                                          </Button>
                                                        ) : (
                                                          <img
                                                            src={noImg}
                                                            style={fotoStyle}
                                                            alt={
                                                              itemNotePicture.errorCodeName
                                                            }
                                                          />
                                                        )}
                                                      </div>
                                                      <Modal
                                                        isOpen={self.isOpen}
                                                        toggle={self1.toggle}
                                                      >
                                                        <ModalHeader
                                                          toggle={self1.toggle}
                                                        ></ModalHeader>
                                                        <img
                                                          className="modalImage"
                                                          src={self.isImage}
                                                          style={fotoStyle}
                                                          alt={
                                                            itemNotePicture.errorCodeName
                                                          }
                                                        />
                                                      </Modal>
                                                    </>
                                                  );
                                                }
                                              )}
                                            </Row>
                                          )}
                                      </td>
                                    </tr>
                                  </table>
                                  <CgnButton
                                    type="button"
                                    color="success"
                                    className="printButton ml-3 mt-2 mb-2"
                                    onClick={() =>
                                      self1.addModalUpdateNote(item.guid)
                                    }
                                    text="Güncelle"
                                  />
                                  <CgnButton
                                    type="button"
                                    color="danger"
                                    style={{ width: "90px" }}
                                    className="ml-3 mt-2 mb-2"
                                    onClick={() =>
                                      self1.handleNoteDelete(item.guid)
                                    }
                                    text="Sil"
                                  />
                                </AccordionItemPanel>
                              </AccordionItem>
                            </Accordion>
                          </>
                        </tbody>
                      );
                    })}
                  </Table>
                </>
              )}
            </Card>
            <CgnButton
              type="button"
              color="success"
              className="printButton mr-3"
              onClick={() => this.handlePdfPrint(this.state.urlSplit)}
              text={"Yazdır"}
            />
            <CgnButton
              style={{ display: this.state.customerEmail !== "" ? "" : "none" }}
              type="button"
              color="primary"
              className="sendEmailButton"
              onClick={() => this.handlePdfSendMail(this.state.urlSplit)}
              text={"E-Mail Gönder"}
            />
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>

        <Modal
          isOpen={this.state.isOpenModalNote}
          toggle={this.addModalNote}
          className="modal-xl content"
        >
          <ModalBody className="modalBody">
            <NoteAddUpdate guid={this.state.guid} updated={false} />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalNote}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.isOpenModalUpdateNote}
          toggle={this.addModalUpdateNote}
          className="modal-xl content"
        >
          <ModalBody className="modalBody">
            <NoteAddUpdate guid={this.state.noteGuid} updated={true} />
          </ModalBody>
          <ModalFooter>
            <CgnButton
              type="button"
              color="secondary"
              onClick={this.addModalUpdateNote}
              text="Kapat"
              className="modalButton"
            />
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default OfferDetail;
